<template>
  <div>
    <NavBar />
    <div class="container">
      <div class="row justify-content-center">
        <div class="col col-md-8 col-lg-6">
          <h1 class="text-center">Create User</h1>
          <ErrorSummary :error="error" />
          <div class="card">
            <h5 class="card-header">Profile</h5>
            <div class="card-body">
              <form ref="form" class="needs-validation" :class="formWasValidated ? 'was-validated' : ''" novalidate @submit.prevent>
                <div class="form-group">
                  <label for="emailAddress">Email</label>
                  <input
                    v-model="emailAddress"
                    type="email"
                    class="form-control"
                    id="emailAddress"
                    placeholder="Email Address"
                    required
                    :disabled="loadingMessage"
                    @keyup.enter="submit"
                    style="text-transform: lowercase;"
                  />
                  <div class="invalid-feedback">
                    Please provide an email address.
                  </div>
                </div>
                <div class="form-group">
                  <label for="fullName">Full Name</label>
                  <input
                    v-model="fullName"
                    type="text"
                    class="form-control"
                    id="fullName"
                    placeholder="full name"
                    required
                    :disabled="loadingMessage"
                    @keyup.enter="submit"
                  />
                  <div class="invalid-feedback">
                    Please provide a full name.
                  </div>
                </div>
                <div class="form-group">
                  <label for="mobilePhoneNumber">Mobile Phone</label>
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text" id="inputGroupPrepend">+1</span>
                    </div>
                    <input
                      v-model="editorMobilePhoneNumber"
                      type="tel"
                      pattern="^\d{3}[\-]?\d{3}[\-]?\d{4}$"
                      class="form-control"
                      id="mobilePhoneNumber"
                      placeholder="555-555-5555"
                      :disabled="loadingMessage"
                      @keyup.enter="submit"
                    />
                    <div class="invalid-feedback">
                      Please provide a valid mobile phone number.
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div class="card mt-4">
            <h5 class="card-header">Roles</h5>
            <div class="card-body">
              <form class="needs-validation" novalidate @submit.prevent>
                <div class="form-group" v-for="r in allRoles" :key="r.code">
                  <div class="form-check">
                    <input class="form-check-input" type="checkbox" :value="r.code" :id="r.code" v-model="roles" :disabled="loadingMessage" />
                    <label class="form-check-label" :for="r.code"
                      >{{ r.shortDescription }} <small class="form-text text-muted">{{ r.longDescription }}</small></label
                    >
                  </div>
                </div>
              </form>
            </div>
          </div>
          <button type="button" class="btn btn-primary btn-block mt-4" @click="submit" :disabled="loadingMessage" @keyup.enter="signIn">
            <span v-if="loadingMessage" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            {{ loadingMessage ? loadingMessage : "Create" }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NavBar from "@/views/reports/NavBar.vue";
import ErrorSummary from "@/components/ErrorSummary.vue";

export default {
  components: {
    NavBar,
    ErrorSummary,
  },
  props: {
    organizationId: String,
  },
  data() {
    return {
      loadingMessage: null,
      formWasValidated: false,
      error: null,

      allRoles: [],

      emailAddress: null,
      fullName: null,
      mobilePhoneNumber: null,
      roles: [],
    };
  },
  computed: {
    editorMobilePhoneNumber: {
      get() {
        if (!this.mobilePhoneNumber) return null;
        var value = this.mobilePhoneNumber.replace(/^\+1/, ""); // remove prefix
        if (value.length >= 3) value = value.substr(0, 3) + "-" + value.substr(3); // insert dash
        if (value.length >= 7) value = value.substr(0, 7) + "-" + value.substr(7); // insert dash
        return value;
      },
      set(newValue) {
        this.mobilePhoneNumber = ""; // force input value update
        this.mobilePhoneNumber = "+1" + (newValue || "").replace(/[^0-9]/g, ""); // add +1 and remove non-numeric characters
      },
    },
  },
  created() {
    this.loadingMessage = "Loading...";
    this.$axios
      .get(`/v1/organizations/${this.organizationId}/roles`)
      .then(res => (this.allRoles = res.data))
      .finally(() => (this.loadingMessage = null));
  },
  methods: {
    reset() {
      this.loadingMessage = null;
      this.formWasValidated = false;
      this.error = null;
    },
    submit() {
      const payload = {
        organizationId: this.organizationId,
        emailAddress: this.emailAddress != null ? this.emailAddress.toLowerCase() : this.emailAddress,
        fullName: this.fullName,
        mobilePhoneNumber: this.mobilePhoneNumber,
        roles: this.roles,
      };

      // reset
      this.reset();

      // validations
      if (!this.$refs.form.checkValidity()) {
        this.formWasValidated = true;
        return;
      }

      // api
      this.loadingMessage = "Saving...";
      this.$axios
        .post(`/v1/organizations/${this.organizationId}/users`, payload)
        .then(res => this.$router.push(`/organizations/${this.organizationId}/users/${res.data.id}`))
        .catch(err => (this.error = err))
        .finally(() => (this.loadingMessage = null));
    },
  },
};
</script>
